import axios from 'axios';
import cookies from 'js-cookie';
import ApiError, {ApiIsLoginError, NotLoginCode} from './cms-errors'

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export async function httpGet(url, params = {}, headers = {}, prefix = "/api", isBlob = false) {
  const api_key = cookies.get('api_key')
  if (!api_key) {
    const apiError = new ApiError("not login")
    apiError.ErrorCode = NotLoginCode
    throw apiError
  }

  const config = {
    params,
    headers,
  };
  
  if (isBlob) {
    config.responseType = 'blob';
  }

  const response = await axiosInstance.get(`${prefix}${url}`, config);

  if (isBlob) {
    return response.data; // For blob responses, return the raw data
  }

  const {status, error} = response.data;

  if (status !== 'OK') {
    if (ApiIsLoginError(error)) {
      const apiError = new ApiError("not login")
      apiError.ErrorCode = NotLoginCode
      throw apiError
    }
    const errorMessage = typeof error === 'object' && error?.error ? error.error : error;
    throw new Error(errorMessage);
  }

  return response.data
}

export async function httpPost(url, data = {}, headers = {}, prefix = "/api") {
  const api_key = cookies.get('api_key')
  if (!api_key) {
    const apiError = new ApiError("not login")
    apiError.ErrorCode = NotLoginCode
    throw apiError
  }

  const response = await axiosInstance.post(`${prefix}${url}`, data, {
    headers,
  });

  const {status, error} = response.data;

  if (status !== 'OK') {
    if (ApiIsLoginError(error)) {
      const apiError = new ApiError("not login")
      apiError.ErrorCode = NotLoginCode
      throw apiError
    }
    const errorMessage = typeof error === 'object' && error?.error ? error.error : error;
    throw new Error(errorMessage);
  }

  if ('cms-site-id' in headers) {
    if (url === '/post/create'
      || url === '/post/update'
      || url === '/post/delete'
      || url === '/post/change_rank'
      || url === 'post/change_top_last_rank'
      || url === '/post/type/create'
      || url === '/post/type/update'
      || url === '/post/type/delete'
      || url === '/category/create'
      || url === '/category/update'
      || url === '/category/delete'
      || url === '/category/rank/update'
      || url === '/page/create'
      || url === '/page/update'
      || url === '/page/delete'
      || url === '/page/post/create'
      || url === '/page/post/update'
    ) {
      pageCacheMasterVersionUpdate(headers['cms-site-id']).then({});
    }
  }

  return response.data
}

export function pageCacheMasterVersionUpdate(site_id) {
  return httpPost("/shopify-page-cache-master-version-update", {}, {
    "cms-site-id": site_id,
  }, "");
}
